import { ReactNode, useState } from 'react';

import { Dialog } from '@gasbi/shared/web/components/Dialog';

import Button from '@mui/joy/Button';

import InfoMessage from '@components/ui/InfoMessage';

export const ConfirmDialog = ({
  icon,
  error,
  title,
  subtitle,
  actions,
}: any) => {
  return (
    <Dialog
      open
      actions={
        <>
          {!!actions.cancel && (
            <Button
              size='sm'
              variant='plain'
              onClick={actions.cancel.fn}
              sx={{
                color: theme =>
                  theme.palette.isDarkMode
                    ? theme.palette.neutral[700]
                    : theme.palette.primary[500],
              }}
            >
              {actions.cancel.caption}
            </Button>
          )}
          {!!actions.submit && (
            <Button size='sm' onClick={actions.submit.fn}>
              {actions.submit.caption}
            </Button>
          )}
        </>
      }
      sx={{
        '.MuiPaper-root': {
          maxWidth: '480px',
          width: '100%',
        },
      }}
    >
      <InfoMessage
        icon={icon}
        error={error}
        title={title}
        subtitle={subtitle}
      />
    </Dialog>
  );
};

const useConfirmDialog = () => {
  const [data, setData] = useState<any>();

  return {
    isOpen: !!data,
    confirm: (fn: () => void, config: any = {}) => {
      setData({
        ...config,
        actions: {
          submit: {
            caption: config.submit,
            fn: () => {
              fn();
              setData(undefined);
            },
          },
          cancel: {
            caption: config.cancel,
            fn: () => {
              setData(undefined);
            },
          },
        },
      });
    },
    ConfirmDialog: ({
      icon,
      title,
      subtitle,
      hideSubtitle,
      submit,
      cancel,
    }: {
      icon?: ReactNode;
      title?: string;
      subtitle?: ReactNode;
      hideSubtitle?: boolean;
      submit?: string;
      cancel?: string;
    }) => {
      if (!data) {
        return null;
      }

      const config = Object.assign(data, {
        icon,
        title: title || data.title || 'Ви впевнені, що хочете закрити вікно?',
        subtitle: !hideSubtitle
          ? subtitle ||
            data.subtitle ||
            'Скасування заповнення форми призведе до втрати внесених даних.'
          : null,
        actions: {
          submit: {
            caption: data?.actions?.submit?.caption || submit || 'Закрити',
            fn: data?.actions?.submit?.fn,
          },
          cancel: {
            caption: data?.actions?.cancel?.caption || cancel || 'Повернутися',
            fn: data?.actions?.cancel?.fn,
          },
        },
      });
      return <ConfirmDialog {...config} />;
    },
  };
};

export default useConfirmDialog;
